import ReactECharts from "echarts-for-react";
import type { EChartsOption } from "echarts";

interface IEChartsWrapperProps {
  option: EChartsOption;
  height?: string;
}

export const EChartsWrapper = ({
  option,
  height = "320px",
}: IEChartsWrapperProps): JSX.Element => {
  return (
    <ReactECharts
      option={option}
      style={{ height, width: "100%" }}
      notMerge
      opts={{ renderer: "svg" }}
    />
  );
};
